import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LangToggle } from "./LangToggle";
import { trackContactConversion } from "@/lib/gtag";

export const Header = () => {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const NAV = [
    { label: t("nav.platforms"), to: "/platforms" },
    { label: t("nav.sectors"), to: "/sectors" },
    { label: t("nav.model"), to: "/engagement" },
    { label: t("nav.about"), to: "/about" },
    { label: t("nav.impact"), to: "/impact" },
  ];

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled || open
          ? "bg-background/40 backdrop-blur-2xl backdrop-saturate-150 border-b border-white/10 shadow-[0_8px_32px_-8px_hsla(0,0%,0%,0.5)]"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex h-16 items-center justify-between">
        <Link to="/" className="font-display text-xl font-medium tracking-tight text-foreground">
          ARANON
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `text-sm transition-colors ${
                  isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <LangToggle className="hidden sm:inline-flex" />
          <Link
            to="/contact"
            onClick={trackContactConversion}
            className="hidden sm:inline-flex items-center gap-2 glass-pill rounded-full px-4 py-2 text-xs font-medium text-foreground"
          >
            {t("nav.getStarted")} <span aria-hidden>→</span>
          </Link>
          <button
            type="button"
            aria-label="Menu"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex h-9 w-9 items-center justify-center glass-pill rounded-full text-foreground"
          >
            <span aria-hidden>{open ? "✕" : "≡"}</span>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background">
          <nav className="container-x flex flex-col py-4 gap-3">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="text-sm text-muted-foreground hover:text-foreground"
              >
                {item.label}
              </NavLink>
            ))}
            <div className="pt-2 flex items-center justify-between">
              <LangToggle />
              <Link
                to="/contact"
                onClick={() => { setOpen(false); trackContactConversion(); }}
                className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-xs font-medium text-primary-foreground"
              >
                {t("nav.getStarted")} →
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
